import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import {
  DebitAlreadyPaidError,
  MethodWorksOnlyForLastDebitError,
  HTTPResponseError,
} from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

type Params = {
  idUser: number;
  idDebit: number;
};

export const payDebitManual = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('payDebitManual'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    if (response.status === 400) {
      const data = await response.json();

      if (data.message === m8ErrorMessageMap.DEBIT_ALREADY_PAID) {
        throw new DebitAlreadyPaidError();
      }

      if (data.message === m8ErrorMessageMap.METHOD_WORKS_ONLY_FOR_LAST_DEBIT) {
        throw new MethodWorksOnlyForLastDebitError();
      }
    }

    throw new HTTPResponseError(response);
  }
};
